import * as absences from "./absences";

const types = {
  ...absences,
};

export default types;
